const STORAGE_KEY = "recentSubmittedOrders";
const MAX_RECENT_ORDERS = 10;
const EXPIRATION_TIME = 24 * 60 * 60 * 1000; // 1 day

export const saveRecentOrder = (order) => {
    try {
        const existing =
            JSON.parse(
                localStorage.getItem(STORAGE_KEY) || "[]"
            );

        if (!Array.isArray(order)) {
            return;
        }

        // Combine new items + existing items
        const combined = [
            ...order,
            ...existing,
        ];

        // Remove duplicate itemName
        // Newest item is kept
        const uniqueItems = [];
        const itemNames = new Set();

        for (const item of combined) {

            const itemName =
                String(item.itemName || "")
                    .trim()
                    .toLowerCase();

            // Skip empty item names
            if (!itemName) {
                continue;
            }

            // Skip duplicate item names
            if (itemNames.has(itemName)) {
                continue;
            }

            itemNames.add(itemName);

            uniqueItems.push({
                ...item,
                savedAt:
                    item.savedAt ||
                    new Date().toISOString(),
            });
        }

        // Keep only latest items
        const limited =
            uniqueItems.slice(
                0,
                MAX_RECENT_ORDERS
            );

        localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify(limited)
        );

    } catch (error) {

        console.error(
            "Failed to save recent order:",
            error
        );

    }
};


export const getRecentOrders = () => {
    try {
        const stored =
            localStorage.getItem(STORAGE_KEY);

        if (!stored) {
            return [];
        }

        const orders = JSON.parse(stored);

        if (!Array.isArray(orders)) {
            return [];
        }

        const now = Date.now();

        // Keep only orders that are less than 24 hours old
        const validOrders = orders.filter((order) => {

            if (!order.savedAt) {
                return false;
            }

            const savedTime =
                new Date(order.savedAt).getTime();

            return (
                now - savedTime < EXPIRATION_TIME
            );
        });

        // Update localStorage if expired orders were removed
        if (validOrders.length !== orders.length) {

            localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify(validOrders)
            );

        }

        return validOrders;

    } catch (error) {

        console.error(
            "Failed to get recent orders:",
            error
        );

        return [];
    }
};


export const removeRecentOrder = (orderId) => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);

        if (!stored) {
            return false;
        }

        const orders = JSON.parse(stored);

        if (!Array.isArray(orders)) {
            return false;
        }

        const updatedOrders = orders.filter(
            (order) => order.orderId !== orderId
        );

        localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify(updatedOrders)
        );

        return true;

    } catch (error) {

        console.error(
            "Failed to remove recent order:",
            error
        );

        return false;
    }
};